import { useState, useEffect } from 'react';
import { useLocalStorage } from 'hooks/localstorage';
import Image from 'next/image';
import Timer from './display';
import Faq from '../faq';
import Rating from '../rating';
import SimpleDisplay from './simpledisplay';

import { useTranslations } from 'next-intl';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { timersState, timerInfoState } from 'store/atoms';
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import Snackbar from '@mui/material/Snackbar';


const commonModes = [{
    id: 'manual',
    name: "Manually"
}, {
    id: 'sequence',
    name: "Start in sequence"
}, {
    id: 'startall',
    name: "Start all together"
}, {
    id: 'endall',
    name: "End all together"
},
];


export default function Main({ lang_code, page_content, embed = false, faq }) {
    const t = useTranslations();
    const fullscreenfn = useFullScreenHandle();
    const timers = useRecoilValue(timersState);
    const setTimers = useSetRecoilState(timersState);
    const [lstimers, setLstimers] = useLocalStorage("lstimers");
    const [lsmode, setLsmode] = useLocalStorage("lsmode");
    const [lsStartedTimers, setLsStartedTimers] = useLocalStorage("lsStartedTimers");
    const [removed, setRemoved] = useState(false);
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState('manual');
    const [mounted, setMounted] = useState(false);
    const timerinfo = useRecoilValue(timerInfoState);
    const setTimerinfo = useSetRecoilState(timerInfoState);
    const [started, setStarted] = useState(0)
    useEffect(() => {
        setMounted(true);
        console.log("====timers=====", timers);
        console.log("====lstimers=====", lstimers);
        // console.log("useEffect timers", timers);
        if (timers.length === 0 && lstimers && lstimers.length > 0) {
            setTimers([...lstimers])
        }
        setLstimers([...timers])


    }, [timers]);

    useEffect(() => {
        console.log("====lsStartedTimers====", lsStartedTimers);
        setMode(lsmode);
        setStarted(lsStartedTimers);
    }, [lsmode, lsStartedTimers]);

    const openDisplay = () => {
        setOpen(true);
    };

    const cancelDisplay = () => {
        setOpen(false);
    }

    const removeTimer = (index) => {
        let new_list = [...timers];
        new_list.splice(index, 1);
        setTimers([...new_list]);
        setLstimers([...new_list]);
        setRemoved(true);
    };

    /*
     const handleMode = (event, newMode) => {
        setMode(newMode);
        setLsmode(newMode);
        setLsStartedTimers(0);
       
    }
    
    const startTimers = () => {
        setStarted(true);
        setLsStartedTimers(1);


        if (mode === "sequence") {
            const _min = Math.min(...[...timers.map(v => v.total_in_ms_raw_left)]);
            setTimers([...(timers ? timers.map(v => {
                if (v.total_in_ms_raw_left === _min) {
                    return {
                        ...v,
                        started_outside: true
                    }
                } else {
                    return v
                }
            }) : [])]);

        }
        Router.reload(window.location.pathname);
    }
    const pauseTimers = () => {
        setStarted(false);
        setLsStartedTimers(0);
        setTimers([...(timers ? timers.map(v => {
            return {
                ...v,
                started: false,
                started_outside: false
            }
        }) : [])]);
        setTimerinfo({
            ...timerinfo,
            paused: true
        })

    }
    const resetTimers = () => {

    }*/


    const timer_info = [{
        icon: (<Image width="43px" height="43px" src={'/images/icon_easy.svg'} />),
        text: t('key_timer_info_2')
    }, {
        icon: (<Image width="43px" height="43px" src={'/images/icon_date.svg'} />),
        text: t('key_timer_info_3')
    }];



    return (
        <>
            <div className="timer-container">

                <FullScreen handle={fullscreenfn}>
                    <div className='available-timers'>
                        {!open && mounted && timers && timers.length > 0 && timers.map((v, i) => {
                            return (<SimpleDisplay
                                singleTimer={timers && timers.length ? timers.length : 0}
                                timer={v}
                                index={i}
                                key={v.id}
                                removeItem={removeTimer}
                            />)
                        })}
                    </div>
                    {/*mode !== "manual" && timers.length > 1 && <div className='d-flex m-top-40 m-bottom-20'>
                        <div className='sub-operations'>
                            {!started && <div className="btn-div">
                                <Button variant="contained" onClick={startTimers}  >
                                    {t('Start')}
                                </Button>
                            </div>}
                            {started && <div className="btn-div">
                                <Button variant="contained" onClick={pauseTimers}  >
                                    {t('Stop')}
                                </Button>
                            </div>}
                            <div className={mode === "sequence" ? `btn-div yellow-btn-div` : `btn-div disabled-btn-div`}>
                                <Button variant="contained" onClick={mode === 'sequence' ? resetTimers : () => { }} className="m-right-15" >
                                    {t('Reset')}
                                </Button>
                            </div>
                        </div>
                    </div>*/
                    }
                    {/*timers && timers.length > 1 && <div className="start-modes">
                        <div className="common-times">
                            <ToggleButtonGroup
                                exclusive={true}
                                value={mode}
                                className={''}
                                onChange={handleMode}
                                aria-label="text formatting"
                            >
                                {commonModes.map((v, i) => {
                                    return (<ToggleButton value={v.id} key={i} aria-label={v.name}>
                                        {v.name}
                                    </ToggleButton>)
                                })}
                            </ToggleButtonGroup>
                        </div>
                    </div>*/}
                    <div className="display-container my-container">
                        <Timer alreadyAdded={timers && timers.length > 0 ? true : false} fullscreenfn={fullscreenfn} cancelDisplay={cancelDisplay} />
                    </div>
                </FullScreen>
                {!embed && <>
                    <div className="my-container info-block m-top-40">
                        {timer_info.map((v, i) => {
                            return (<div key={i} className="info-block-each">
                                <div className="info-block-each-icon">{(i + 1)})</div>
                                <div className="info-block-each-text">{v.text}</div>
                            </div>)
                        })}
                    </div>
                    <div className='my-container m-top-28 page-content-coantainer'>
                        {page_content}
                    </div>
                    {<Faq faq={faq} from={'timer'} lang_code={lang_code} />}

                </>}
            </div >
            <Snackbar
                open={removed}
                autoHideDuration={5000}
                message={t('Timer removed!')}
                onClose={() => setRemoved(false)}
            />
        </>
    )
}


